<h2 class="p-6 pb-4">{{ service() ? "Редагування медичної послуги" : "Додавання медичної послуги" }}</h2>
<div class="overflow-y-auto px-6 py-0">
  @if (!loading()) {
    <div
      class="rounded-lg border-2 border-transparent p-3 shadow-inner"
      [formGroup]="serviceForm"
      [ngClass]="{ 'border-warning-500': mappingInvalid() }"
    >
      @if (mappingInvalid()) {
        <div class="paragraph-2 mb-4 rounded-xl bg-warning-50 p-4 text-warning-600">
          {{ "prescription.message.invalidMappingWarning" | translate }}
        </div>
      }
      <mat-form-field class="mt-2 w-full">
        <mat-label>Тип послуги</mat-label>
        @if (originalMappingInvalid()) {
          <mat-select formControlName="type">
            @for (type of editableServiceTypes; track type) {
              <mat-option [value]="type">
                {{ "medicalServices.prescriptionTypes." + type | translate }}
              </mat-option>
            }
          </mat-select>
        } @else {
          <input
            matInput
            readonly
            type="text"
            [value]="'medicalServices.prescriptionTypes.' + fc.type.value | translate"
          />
        }
      </mat-form-field>
      @if (originalMappingInvalid()) {
        <p class="paragraph-2 -mt-2 mb-4 text-warning-600">
          {{ "prescription.message.invalidMappingTypeChangeAllowed" | translate }}
        </p>
      }

      <mat-form-field class="w-full">
        <mat-label>Назва послуги</mat-label>
        <input
          matInput
          type="text"
          formControlName="name"
          [matAutocomplete]="relatedSpecialistAutocomplete"
        />
        <mat-autocomplete
          #relatedSpecialistAutocomplete="matAutocomplete"
          (optionSelected)="selectServiceOption(serviceForm, $event.option.value)"
        >
          @for (option of servicesOptions(); track option) {
            <mat-option [value]="option">{{ option.nameUa }} ({{ option.code }})</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      @if (mappingInvalid()) {
        <p class="paragraph-2 -mt-2 mb-4 text-warning-600">
          {{ "prescription.message.invalidMappingShouldBeUpdated" | translate }}
        </p>
      }

      <div class="flex w-full gap-4">
        <mat-form-field class="w-1/2">
          <mat-label>Дата з</mat-label>
          <input
            matInput
            formControlName="startDate"
            [matDatepicker]="dateFromPicker"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="dateFromPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #dateFromPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="w-1/2">
          <mat-label>Дата до</mat-label>
          <input
            matInput
            formControlName="endDate"
            [matDatepicker]="dateTillPicker"
            [min]="serviceForm.get('startDate').value"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="dateTillPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #dateTillPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <mat-form-field
        class="w-full"
        [formGroupName]="'metadata'"
      >
        <mat-label>Кількість</mat-label>
        <input
          matInput
          formControlName="quantity"
          type="number"
          onkeypress="return event.charCode >= 48;"
          [readonly]="prescriptionType() === prescriptionTypes.LaboratoryService"
          [min]="1"
        />
      </mat-form-field>
      <div class="flex w-full gap-4">
        <mat-form-field class="full grow">
          <mat-label>Франшиза</mat-label>
          <input
            matInput
            formControlName="franchise"
            type="number"
            [max]="100"
            [min]="0"
          />
          @if (fc.franchise.hasError("required")) {
            <mat-error class="text-red-error">Поле обов'язкове для заповнення (ціле число від 0 до 100)</mat-error>
          }
          @if (fc.franchise.hasError("max")) {
            <mat-error class="text-red-error">Франшиза не може бути більше 100%</mat-error>
          }
          @if (fc.franchise.hasError("min")) {
            <mat-error class="text-red-error">Франшиза не може бути менше 0%</mat-error>
          }
          @if (fc.franchiseManualChangeConfirmation.hasError("required")) {
            <mat-hint class="text-red-error">Перевірте та підтвердіть зміну відсотку франшизи</mat-hint>
          }
        </mat-form-field>
        @if (franchiseInitialValue() !== fc.franchise.value) {
          <mat-checkbox
            formControlName="franchiseManualChangeConfirmation"
            matTooltip="Підтверджую зміну відсотку франшизи"
            matTooltipPosition="above"
            color="primary"
          >
          </mat-checkbox>
        }
      </div>
      <mat-form-field class="w-full">
        <mat-label>Статус</mat-label>
        <mat-select formControlName="guaranteeStatus">
          @for (status of guaranteeStatusOptions; track status) {
            <mat-option
              [value]="status"
              [ngClass]="{ '!hidden': status === guaranteeStatus.Auto || status === guaranteeStatus.Unknown }"
            >
              {{ "statuses.guarantationStatuses." + status | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (statusChanged()) {
        @if (fc.guaranteeStatus.value === guaranteeStatus.Guaranteed) {
          <mat-form-field class="w-full">
            <mat-label>{{ "prescription.label.editReason" | translate }}</mat-label>
            <input
              matInput
              formControlName="statusReason"
            />
          </mat-form-field>
        } @else {
          <mat-form-field class="w-full">
            <mat-label>{{ "prescription.label.declineReason" | translate }}</mat-label>
            <input
              matInput
              type="text"
              formControlName="statusReason"
              [matAutocomplete]="declineReasonAutocomplete"
            />
            <mat-autocomplete #declineReasonAutocomplete="matAutocomplete">
              @for (reason of filteredDeclineReasons(); track reason) {
                <mat-option [value]="reason">
                  {{ reason }}
                </mat-option>
              }
            </mat-autocomplete>
            @if (fc.statusReason.value) {
              <button
                matSuffix
                mat-icon-button
                type="button"
                aria-label="Clear"
                (click)="clearStatusReason()"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
        }
      }
      @if (dataChanged()) {
        <mat-form-field class="w-full">
          <mat-label>Причина редагування</mat-label>
          <input
            matInput
            type="text"
            formControlName="editReason"
            [matAutocomplete]="editReasonAutocomplete"
          />
          <mat-autocomplete #editReasonAutocomplete="matAutocomplete">
            @for (reason of filteredEditReasons(); track reason) {
              <mat-option [value]="reason">
                {{ reason }}
              </mat-option>
            }
          </mat-autocomplete>
          @if (fc.editReason.value) {
            <button
              matSuffix
              mat-icon-button
              type="button"
              aria-label="Clear"
              (click)="clearEditReason()"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      }

      @if (
        !!this.guaranteeApplicationId() &&
        (this.fc.guaranteeStatus.value === this.guaranteeStatus.Auto || this.fc.guaranteeStatus.value === this.guaranteeStatus.Guaranteed) &&
        (!this.service() || !!this.service()?.creationDate)
      ) {
        <div class="mb-4 flex items-center gap-4">
          <mat-checkbox [formControl]="fc.completedInAppointment">{{ "prescription.label.completed" | translate }}</mat-checkbox>
        </div>

        @if (!!fc.completedInAppointment.value) {
          <mat-form-field class="w-full">
            <mat-label>{{ "prescription.label.completionReason" | translate }}</mat-label>
            <input
              matInput
              type="text"
              [formControl]="fc.completionReason"
            />
            @if (fc.completionReason?.invalid) {
              <mat-error class="text-sm text-red-error-dark">{{ "validation.error.required" | translate }}</mat-error>
            }
          </mat-form-field>
        }
      }
    </div>
  } @else {
    <div class="flex items-center justify-center">
      <shared-loader></shared-loader>
    </div>
  }
</div>

<div class="flex justify-end gap-4 p-6">
  <button
    class="btn btn-secondary"
    [type]="'button'"
    [disabled]="loading()"
    (click)="closeDialog()"
  >
    Скасувати
  </button>
  <button
    class="btn btn-primary"
    [type]="'submit'"
    [disabled]="loading() || fc.completedInAppointment.value === true"
    (click)="submitDraft()"
  >
    Зберегти чернетку
  </button>
  @if (!!guaranteeApplicationId() && (!service() || !!service()?.creationDate)) {
    <button
      class="btn btn-primary"
      [type]="'submit'"
      [disabled]="loading()"
      (click)="submitPrescription()"
    >
      Зберегти
    </button>
  }
</div>
